import { render, staticRenderFns } from "./WaypointList.vue?vue&type=template&id=63a232c6"
import script from "./WaypointList.vue?vue&type=script&lang=js"
export * from "./WaypointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports